/**
 * @module Utils.File
 *
 */
import { Promise, reject } from 'rsvp';

/**
 * Reads a file as data url.
 *
 * @param {File} file
 * @returns {Promise<Blob>}
 */
export default function readAsDataUrl(file: File | Blob): Promise<string> {
  if ('FileReader' in window) {
    const reader = new FileReader();

    return new Promise((resolve) => {
      reader.addEventListener('load', () => {
        resolve((reader.result as string));
      });
      reader.readAsDataURL(file);
    });
  }

  return reject(new Error('FileReader is not supported.'));
}
